"use strict";'use strict';

var chunk2K6D4BJW_js = require('./chunk-2K6D4BJW.js');
require('./chunk-XONZ6KNI.js');



module.exports = chunk2K6D4BJW_js.Contact_default;
